<template>
  <div class="section-title">
    <span class="section-title__badge" v-if="tag">{{ tag }}</span>
    <h2>{{ title }}</h2>
    <p v-if="subtitle" class="section-title__sub">{{ subtitle }}</p>
    <div class="section-title__decoration">
      <span class="line line--left"></span>
      <span class="leaf">🍀</span>
      <span class="line line--right"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    tag: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  text-align: center;
  margin-bottom: 3.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__badge {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    color: var(--color-primary);
    background: var(--color-primary-light);
    padding: 0.25rem 0.875rem;
    border-radius: 50px;
    margin-bottom: 0.75rem;
    display: inline-block;
  }

  h2 {
    font-size: 2.25rem;
    font-weight: 700;
    color: var(--color-dark);
    margin-bottom: 0.5rem;
    letter-spacing: 0.03em;
  }

  &__sub {
    color: var(--color-text-muted);
    font-size: 1.05rem;
    margin-bottom: 0.75rem;
    max-width: 600px;
    line-height: 1.5;
  }

  &__decoration {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-top: 0.25rem;

    .line {
      width: 2.5rem;
      height: 2px;
      border-radius: 2px;
      background: linear-gradient(to right, transparent, var(--color-primary));

      &--right {
        background: linear-gradient(to left, transparent, var(--color-primary));
      }
    }

    .leaf {
      font-size: 0.875rem;
      opacity: 0.85;
      display: inline-block;
      animation: gentle-wave 3s ease-in-out infinite alternate;
    }
  }
}

@keyframes gentle-wave {
  0% { transform: rotate(-5deg); }
  100% { transform: rotate(5deg); }
}

@media (max-width: 768px) {
  .section-title {
    margin-bottom: 2.5rem;

    h2 {
      font-size: 1.75rem;
    }
    &__sub {
      font-size: 0.95rem;
    }
  }
}
</style>
